export default __webpack_public_path__ + "static/media/invocom-logo.91da9f13.svg";